import Get from "../Get";
import Post from "../Post";
import getToken from "../token";

export default function getTutorialDetail(id) {
  return Post("blog/blogDetailes", { id: id, token: getToken(), type: "user" });
}
